import { getV2ApiCompanyIdUsersUserIdAuthenticationFactors } from 'src/client/spendesk-api';
import { type GetV2ApiCompanyIdUsersUserIdAuthenticationFactorsResponseOK } from 'src/client/spendesk-api-types';
import { logger } from 'src/utils/datadog-log-wrapper';

export type GetMemberAuthenticationFactorsInput = {
  companyId: string;
  userId: string;
};

export const getMemberAuthenticationFactors = async ({
  userId,
  companyId,
}: GetMemberAuthenticationFactorsInput): Promise<
  GetV2ApiCompanyIdUsersUserIdAuthenticationFactorsResponseOK['data']
> => {
  logger.debug(
    `Retrieving user authentication factors - company ${companyId} user ${userId}`,
    {
      scope: 'user-authentication-factors',
      team: 'cards-ux',
    },
  );

  const response = await getV2ApiCompanyIdUsersUserIdAuthenticationFactors({
    path: {
      companyId,
      userId,
    },
  });

  if (response.statusCode !== 200) {
    logger.error('Failed to retrieve user authentication factors.', {
      error: response.body,
      scope: 'user-authentication-factors',
      team: 'cards-ux',
    });
    throw new Error('Failed to retrieve user authentication factors.');
  }

  return response.body.data;
};
